<template>
  <div class="m-choose-point">
    <div class="u-modle-p">投放媒体</div>
    <div class="media-content">
      <div class="date-item">
        <div class="item-title">
          <span class="item-important">*</span>投放时间 :
        </div>
        <a-range-picker
          class="release-time"
          :defaultValue="[
            moment(startTime, dateFormat),
            moment(endTime, dateFormat)
          ]"
          :format="dateFormat"
          @change="dateChange"
          @calendarChange="calendarChange"
          @openChange="openChange"
          :disabledDate="disabledDate"
        >
        </a-range-picker>
      </div>
      <div class="point-item">
        <div class="item-title">
          <a-tooltip
            placement="top"
            overlayClassName="point-item-toast"
            trigger="hover"
            :overlayStyle="{ maxWidth: '350px' }"
          >
            <span class="item-important">*</span>素材时长/播放次数
            <template slot="title">
              <span v-if="positionId == 2">
                轮播：要投放的素材时长，以及对每台设备播放的轮播次数要求
                <br />
                触发：要投放的素材时长，以及对应的总曝光次数要求
              </span>
              <span v-else-if="positionId == 3">
                轮播：要投放的素材时长，以及对每台设备播放的轮播次数要求
                <br />
                触发：要投放的素材时长，以及对应的总曝光次数要求
              </span>
              <span v-else-if="positionId == 4">
                轮播：要投放的素材时长，以及对每台设备播放的轮播次数要求
                <br />
                触发：要投放的素材时长，以及对应的总曝光次数要求
              </span>
              <span v-else> N秒的广告在每台设备每天至少播放的次数 </span>
            </template>
            <a-icon
              type="question-circle"
              style="font-size: 14px; color: #bfbfbf"
            />
          </a-tooltip>
          :
        </div>
        <div class="points-select">
          <a-select
            v-if="positionId != 4"
            :value="String(playSecond)"
            style="width: 109px"
            class="first-select"
            @change="selectPoints"
          >
            <a-select-option
              v-for="item in piontsSecond"
              :key="item"
              :value="item"
              >{{ item + "秒" }}</a-select-option
            >
          </a-select>
          <a-select
            v-if="positionId == 4"
            :value="String(noSet)"
            style="width: 109px"
            class="first-select"
            @change="selectPoints"
          >
          </a-select>
          <a-select
            v-if="positionId === 1"
            :value="String(playCounts)"
            style="width: 109px"
            @change="selectCounts"
          >
            <a-select-option
              v-for="val in pointsRules[playSecond]"
              :value="val"
              :key="val"
              >{{ val + "次" }}</a-select-option
            >
          </a-select>
          <a-input-number
            style="border: none"
            v-else
            v-model="playCounts"
            :min="0"
            default-value=""
          />
        </div>
      </div>
      <a-button type="primary" class="search" @click="showModal">搜索</a-button>
      <a-button class="restore-default" @click="resetData">恢复默认</a-button>
      <a-button type="primary" @click="improtPointFun">导入选点</a-button>
    </div>
    <pointVue :visible="importPop" @offPop="offSon" />
  </div>
</template>
<script>
import moment from "moment";
import pointVue from "../common/new/improtPoint";
import { pointsRules } from "../../utils/config.js";
import timeFormat from "../../commomFun/timeFormat";
import $ from "jquery";
import { mapMutations } from "vuex";

// import {getDeliveryPeriodConfig} from '../../commomFun/deliveryPeriodConfig'

const storage = window.sessionStorage;

export default {
  components: {
    pointVue
  },
  props: {
    getAreaDataList: Function,
    deliveryPeriodConfig: Object
  },

  data() {
    return {
      moment,
      noSet: "不限制", //不限制
      startTime: "",
      endTime: "",
      dateFormat: "YYYY/MM/DD",
      pointsRules: {},
      piontsSecond: [],
      // playSecond : JSON.parse(sessionStorage.getItem('formItem')).playSecond,
      playSecond:
        JSON.parse(sessionStorage.getItem("formItem")).playSecond || 10,
      playCounts: "", //新增播放时段选项，播放次数不再一定是300
      startDate: "",
      endDate: "",
      dateArr: [],
      weekDay: 6,
      counts: 1,
      isSuperVip: false,
      nextSaturday: "",
      nextFriday: "",
      needStartTime: "",
      positionId:
        JSON.parse(sessionStorage.getItem("formItem")).positionId || 1,
      importPop: false, //导出选点
      deliveryPeriod:
        JSON.parse(sessionStorage.getItem("formItem")).deliveryPeriod || "", //上一步选择的播放时段
      userType: sessionStorage.getItem("userInfo")
        ? JSON.parse(sessionStorage.getItem("userInfo")).userType
        : sessionStorage.getItem("userInfo").userType,
      isDuration:
        JSON.parse(sessionStorage.getItem("formItem")).isDuration || 10 //上一步选择的播放时段
    };
  },

  methods: {
    ...mapMutations(["clearDate", "clearAdMaterialDetail"]),
    //设置不可选的时间
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().startOf("day");
    },
    //关闭子弹窗
    offSon(v) {
      this.importPop = v;
    },
    //导入选点的事件
    improtPointFun() {
      this.importPop = true;
    },
    showModal() {
      this.$confirm({
        title: "是否确定修改条件",
        content: "更新日期和点位要求，当前已选点位将失效并清空",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          // 父组件获取新的计划条件
          this.getAreaDataList(1);
          const formItem = storage.getItem("formItem")
            ? JSON.parse(storage.getItem("formItem"))
            : storage.getItem("formItem");
          formItem.isDuration = this.playSecond;
          formItem.playSecond = this.playSecond;
          formItem.playCounts = this.playCounts;
          console.log(formItem.playCounts);
          storage.setItem("formItem", JSON.stringify(formItem));
          //修改导入选点参数
          const _obj = JSON.parse(storage.getItem("importWorkeFun"));
          _obj.beginTime = moment(this.startDate).format("YYYY/MM/DD");
          (_obj.endTime = moment(this.endDate).format("YYYY/MM/DD")),
            (_obj.playDuration = this.playSecond);
          _obj.playTimes = Number(this.playCounts);
          storage.setItem("importWorkeFun", JSON.stringify(_obj));
        },
        icon: () => <a-icon type="exclamation-circle" />
      });
    },

    getCurrentStyle(current) {
      const style = {};
      if (current.day() !== this.weekDay) {
        style.position = "relative";
        style.top = "0";
        style.left = "0";
        style.height = "100%";
        style.width = "100%";
        style.background = "#f5f5f5";
        style.pointerEvents = "none";
      } else {
        style.background = "";
      }
      return style;
    },
    resetData() {
      if (
        this.positionId == 3 ||
        this.positionId == 4 ||
        this.positionId == 5
      ) {
        this.playCounts = "";
        if (this.positionId == 3 || this.positionId == 5) {
          this.playSecond = 5;
        } else {
          this.noSet = "不限制";
          this.playSecond = 0;
        }
      } else if (this.positionId == 2) {
        this.playSecond = 10;
        this.playCounts = 300;
      } else {
        this.playSecond = 10;
        switch (Number(this.deliveryPeriod)) {
          case 1:
            //普通时段
            this.playCounts = this.deliveryPeriodConfig.commonPointsRules[
              "10"
            ][0];
            break;
          case 2:
            //黄金时段
            this.playCounts = this.deliveryPeriodConfig.goldPointsRules[
              "10"
            ][0];
            break;
          case 3:
            // 24小时霸屏
            this.playCounts = this.deliveryPeriodConfig.allDayPointsRules[
              "10"
            ][0];
            break;
          default:
            break;
        }
      }

      this.$parent.unlimitedSelect("resetData");
      const formItem = storage.getItem("formItem")
        ? JSON.parse(storage.getItem("formItem"))
        : storage.getItem("formItem");
      if (this.playSecond !== Number(formItem.playSecond)) {
        //恢复默认修改了素材时长,把物料信息重置
        this.clearAdMaterialDetail();
      }
      formItem.isDuration = this.playSecond;
      formItem.playSecond = this.playSecond;
      formItem.playCounts = this.playCounts;
      storage.setItem("formItem", JSON.stringify(formItem));
    },
    getCurrentClass(current) {
      let status = false;
      this.timeout = setTimeout(() => {
        if (this.counts > 1) {
          clearTimeout(this.timeout);
        }
        this.counts++;
        $(".datechange")
          .parent()
          .addClass("ant-calendar-disabled-cell")
          .css({
            pointerEvents: "none"
          });
        //ant-calendar-cell ant-calendar-disabled-cell-last-of-row
        // 上刊时间为周六，下刊为周五，按周投放，投放时间周五之前能选本周六，到了周五只能至少选下周六
        $(".datenochage")
          .parent()
          .removeClass("ant-calendar-disabled-cell")
          .removeClass("ant-calendar-disabled-cell-last-of-row")
          .css({
            pointerEvents: "auto"
          })
          .each((idx, item) => {
            let startTime =
              moment(
                this.weekDay === 5 ? this.nextFriday : this.nextSaturday
              ).format("YYYY-MM-DD") + " 00:00:00";
            startTime = moment(startTime).valueOf();
            const yearId = item.title.indexOf("年");
            const monthId = item.title.indexOf("月");
            const dayId = item.title.indexOf("日");
            let date = item.title.split("");
            date[yearId] = "-";
            date[monthId] = "-";
            date[dayId] = "";
            let parentDate = date.join("");
            const parentTime = new Date(parentDate).getTime();

            if (startTime > parentTime) {
              $(item)
                .addClass("ant-calendar-disabled-cell")
                .css({
                  pointerEvents: "none"
                });
            }
          });
      }, 0);
      if (current.day() !== this.weekDay) {
        return "ant-calendar-date ant-calendar-disabled-cell datechange";
      }
      return "ant-calendar-date datenochage";
    },
    openChange(status) {
      $(".ant-input").css({ borderColor: "#d9d9d9" });
      setTimeout(
        () => $(".ant-calendar-input").css({ pointerEvents: "none" }),
        100
      );
      if (status) {
        this.weekDay = 6;
      }
    },
    checkDate() {
      const formItem = JSON.parse(sessionStorage.getItem("formItem"));
      const beginTime =
        moment(formItem.beginTime).format("YYYY-MM-DD") + " 00:00:00";
      //判断选择时间是否大于等于今天，缓存时间可能是过去时间
      const today = moment(new Date()).format("YYYY-MM-DD") + " 00:00:00";
      if (today > beginTime) {
        $(".ant-input").css({ borderColor: "#f5222d" });
        this.$message.warning("请重新选择投放时间");
        return true;
      } else {
        $(".ant-input").css({ borderColor: "#d9d9d9" });
        this.dateErrStatus = false;
        // callback()
      }
      //关闭周六的校验
      // if (this.isSuperVip) return false
      // const needStartTime =
      //   moment(this.needStartTime).format('YYYY-MM-DD') + ' 00:00:00'
      // //判断下周六的时间是否大于开始时间
      // if (new Date(needStartTime).getTime() > new Date(beginTime).getTime()) {
      //   $('.ant-input').css({ borderColor: '#f5222d' })
      //   this.$message.warning('请重新选择投放时间')
      //   return true
      // } else {
      //   $('.ant-input').css({ borderColor: '#d9d9d9' })
      //   this.dateErrStatus = false
      //   // callback()
      // }
      return false;
    },
    calendarChange(current) {
      const dateArr = [...current];
      if (dateArr.length > 0) {
        this.weekDay = 5;
        let date = new Date(moment(dateArr[0].format("YYYY/MM/DD HH:mm:ss")));
        date.setDate(date.getDate() + 6);
        this.nextFriday = date;
      }
      this.counts = 0;
    },
    dateChange(val) {
      this.startDate = val[0];
      this.endDate = val[1];
      let formItem = JSON.parse(storage.getItem("formItem")) || {};
      if (
        formItem.beginTime != moment(this.startDate).format("YYYY/MM/DD") ||
        formItem.endTime != moment(this.endDate).format("YYYY/MM/DD")
      ) {
        //清空vuex中多画面日期相关数据
        this.clearDate();
      }
      formItem.beginTime = moment(this.startDate).format("YYYY/MM/DD");
      formItem.endTime = moment(this.endDate).format("YYYY/MM/DD");
      storage.setItem("formItem", JSON.stringify(formItem));
    },
    selectPoints(val) {
      if (this.playSecond !== Number(val)) {
        sessionStorage.removeItem("materialDetailsList");
        //改变时长 清空vuex中多画面物料数据
        this.clearAdMaterialDetail();
      }
      this.playSecond = Number(val);
      if (
        this.positionId == 3 ||
        this.positionId == 4 ||
        this.positionId == 5
      ) {
        this.playCounts = "";
      } else if (this.positionId == 1) {
        switch (Number(this.deliveryPeriod)) {
          case 1:
            //普通时段
            this.playCounts = this.deliveryPeriodConfig.commonPointsRules[
              val
            ][0];
            break;
          case 2:
            //黄金时段
            this.playCounts = this.deliveryPeriodConfig.goldPointsRules[val][0];
            break;
          case 3:
            // 24小时霸屏
            this.playCounts = this.deliveryPeriodConfig.allDayPointsRules[
              val
            ][0];
            break;
          default:
            break;
        }
      } else {
        this.playCounts = 300;
      }
    },
    selectCounts(val) {
      this.playCounts = Number(val);
    },
    getPointRules() {
      //初始化选择
      const pointsObj = this.pointsRules;
      const piontsSecond = this.piontsSecond;
      //如果选择触发类型是3/4 的时候从新编辑
      if (
        this.positionId == 3 ||
        this.positionId == 4 ||
        this.positionId == 5
      ) {
        pointsRules["5"] = "";
        if (this.positionId == 3 || this.positionId == 5) {
          this.piontsSecond = ["3", "5", "10", "15", "20", "25", "30"];
        }
        let setSee = JSON.parse(sessionStorage.getItem("formItem"));
        setSee.playCounts = 0;
        sessionStorage.setItem("formItem", JSON.stringify(setSee));
        this.playCounts = "";
        for (let key in pointsRules) {
          const itemArr = pointsRules[key].split(",");
          piontsSecond.push(key);
          pointsObj[key] = itemArr;
        }
        this.playCounts = pointsObj[this.playSecond][0];
        this.pointsRules = pointsObj;
      } else if (this.positionId == 1) {
        switch (Number(this.deliveryPeriod)) {
          case 1:
            //普通时段
            this.piontsSecond = this.deliveryPeriodConfig.commonTimes;
            this.pointsRules = this.deliveryPeriodConfig.commonPointsRules;
            // this.playCounts = 300;
            //这里使用缓存的时长不能写死['10']
            this.playCounts = this.deliveryPeriodConfig.commonPointsRules[
              this.isDuration
            ][0];
            break;
          case 2:
            //黄金时段
            this.piontsSecond = this.deliveryPeriodConfig.goldTimes;
            this.pointsRules = this.deliveryPeriodConfig.goldPointsRules;
            // this.playCounts = 900;
            this.playCounts = this.deliveryPeriodConfig.goldPointsRules[
              this.isDuration
            ][0];
            break;
          case 3:
            // 24小时霸屏
            this.piontsSecond = this.deliveryPeriodConfig.allDayTimes;
            this.pointsRules = this.deliveryPeriodConfig.allDayPointsRules;
            this.playCounts = this.deliveryPeriodConfig.allDayPointsRules[
              this.isDuration
            ][0];
            break;
          default:
            break;
        }
        //初始化素材时常为10s，不使用缓存？因为不同时段时常不一样，之前都是一致的
        //当然也可以在上一步再下一步的时候判断一下播放时段是否修改，修改则清除播放时常缓存
        // this.playSecond = 10
        //还是使用缓存，改动比较少
      } else {
        delete pointsRules["5"];
        for (let key in pointsRules) {
          const itemArr = pointsRules[key].split(",");
          piontsSecond.push(key);
          pointsObj[key] = itemArr;
        }
        this.playCounts = pointsObj[this.playSecond][0];
        this.pointsRules = pointsObj;
      }
    },
    // 初始化时间
    defaultSelectDate() {
      const todayDate = new Date();
      const day = todayDate.getDay();
      const days = Math.abs(6 - day);
      let startTime = todayDate;
      if (day > 4) {
        // 下周六
        startTime.setDate(todayDate.getDate() + days + 7);
      } else {
        // 本周六
        startTime.setDate(todayDate.getDate() + days);
      }
      this.startTime = startTime;
      this.needStartTime = startTime;
      this.nextSaturday = startTime;
      const endTime = new Date(startTime);
      endTime.setDate(todayDate.getDate() + 6);
      this.nextFriday = this.endTime;
      this.endTime = endTime;
      this.startDate = this.startTime;
      this.endDate = this.endTime;
      const formItem = storage.getItem("formItem")
        ? JSON.parse(storage.getItem("formItem"))
        : storage.getItem("formItem");
      if (
        formItem.beginTime === "" ||
        formItem.endTime === "" ||
        formItem.beginTime == "Invalid date" ||
        formItem.endTime === "Invalid date"
      ) {
        formItem.beginTime = moment(this.startDate).format("YYYY/MM/DD");
        formItem.endTime = moment(this.endDate).format("YYYY/MM/DD");
      } else {
        // 有缓存的话，用缓存替代
        this.startDate = formItem.beginTime;
        this.endDate = formItem.endTime;
        this.startTime = moment(formItem.beginTime);
        this.endTime = moment(formItem.endTime);
      }
      storage.setItem("formItem", JSON.stringify(formItem));
    },
    setPlayCount() {
      if (
        this.positionId == 3 ||
        this.positionId == 4 ||
        this.positionId == 5
      ) {
        this.playCounts = "";
      }
      let formItem = JSON.parse(storage.getItem("formItem"));
      //这里猜测应该是判断广告位置，在上一步的时候判断过isDuration等于10为 1 2 4 ， 等于5为 3 5
      if (formItem.isDuration === 10) {
        formItem.isDuration = this.playSecond;
      } else {
        this.playSecond = formItem.playSecond;
      }
      // if (formItem.playCounts = 300) {
      //   //处理精准轮播 在上一步的时候处理过，
      //   this.playCounts =  300;
      // }
      //判断是否是轮播
      formItem.isDuration = this.playSecond;
      formItem.playCounts = this.playCounts;
      formItem.playSecond = this.playSecond;
      storage.setItem("formItem", JSON.stringify(formItem));
    }
  },
  // 可选择的时间段
  created() {
    //初始化播放时常和次数 这代码太乱了，只能哪里有问题补救哪里
    this.playSecond =
      JSON.parse(sessionStorage.getItem("formItem")).playSecond || 10;
    this.isDuration =
      JSON.parse(sessionStorage.getItem("formItem")).playSecond || 10;
    if (!JSON.parse(sessionStorage.getItem("formItem")).playSecond) {
      if (
        this.positionId == 3 ||
        this.positionId == 4 ||
        this.positionId == 5
      ) {
        this.playSecond = 5;
        this.isDuration = 5;
      }
      const formItem = JSON.parse(sessionStorage.getItem("formItem"));
      formItem.playSecond = this.playSecond;
      formItem.isDuration = this.isDuration;
      sessionStorage.setItem("formItem", JSON.stringify(formItem));
    }

    this.defaultSelectDate();
    const { userName } = storage.getItem("userInfo")
      ? JSON.parse(storage.getItem("userInfo"))
      : storage.getItem("userInfo");
    if (
      userName === "qadx_sale" ||
      userName === "dfmj2" ||
      userName === "xs0821"
    ) {
      this.isSuperVip = true;
    } else {
      this.isSuperVip = false;
    }
  },
  mounted() {
    const formItem = storage.getItem("formItem")
      ? JSON.parse(storage.getItem("formItem"))
      : storage.getItem("formItem");
    if (formItem.playCounts != 300) {
      if (this.positionId != 1) {
        //我也不动，判断了一行。 这里应该是从后端拿回的缓存缓存到本地再赋值。我这里不需要
        this.playCounts = formItem.playCounts;
      }
    }
    //上边那个我没动，下边这个是如果类型是3/4、5 就从新赋值
    if (this.positionId == 3 || this.positionId == 4 || this.positionId == 5) {
      this.playCounts = "";
    }
  },
  watch: {
    deliveryPeriodConfig: {
      handler(val) {
        this.deliveryPeriodConfig = val;
        this.$nextTick(() => {
          this.getPointRules(); //防止异步问题，初始化放在获得数据之后
          this.setPlayCount();
        });
      },
      deep: true
    }
  }
};
</script>
<style scoped lang="scss">
.m-choose-point {
  margin-bottom: 16px;
  .u-modle-p {
    width: 100%;
    height: 42px;
    background: rgba(240, 242, 245, 0.41);
    font-size: 18px;
    font-family: "PingFangSC-Regular";
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 42px;
    padding-left: 24px;
    margin-bottom: 32px;
  }
  .media-content {
    display: flex;
    .search {
      width: 74px;
      height: 32px;
      margin-right: 8px;
      font-size: 14px;
      font-family: "PingFangSC-Regular, PingFang SC";
      color: rgba(255, 255, 255, 1);
      line-height: 22px;
    }
    .restore-default {
      width: 74px;
      height: 32px;
      font-size: 14px;
      font-family: "PingFangSC-Regular, PingFang SC";
      color: rgba(0, 0, 0, 0.65);
      line-height: 22px;
      margin-right: 10px;
    }
  }
  .date-item {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .item-title {
      display: flex;
      height: 22px;
      font-size: 14px;
      font-family: "PingFangSC-Regular, PingFang SC";
      font-weight: 400;
      color: #000;
      line-height: 22px;
      .item-important {
        color: rgba(255, 0, 0, 1);
      }
    }
    .release-time {
      width: 300px;
      height: 32px;
      margin-left: 12px;
    }
  }
  .point-item {
    display: flex;
    align-items: center;
    margin-left: 12px;

    .item-title {
      height: 22px;
      font-size: 14px;
      font-family: "PingFangSC-Regular, PingFang SC";
      font-weight: 400;
      color: #000;
      line-height: 22px;

      .item-important {
        color: rgba(255, 0, 0, 1);
      }
    }
    .points-select {
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      margin: 0 12px;
      .first-select {
        border-right: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 0px;
      }
    }
  }

  /deep/ .ant-select-selection:active,
  /deep/ .ant-select-selection:focus,
  /deep/ .ant-select-focused,
  /deep/ .ant-select-selection {
    border: 0 none;
    box-shadow: none;
  }
}
</style>
